import { enableProdMode, importProvidersFrom } from '@angular/core';
import { registerLicense } from '@syncfusion/ej2-base';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@src/app/app.component';
import { AppModule } from './app/app.module';
import { ENVIRONMENT } from './environments/environment';

registerLicense(
    'Ngo9BigBOggjHTQxAR8/V1NMaF1cXmhKYVF2WmFZfVtgdV9EZVZTQ2Y/P1ZhSXxWdkZiWn5dcnFXQWNaUUY='
);

if (ENVIRONMENT.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(AppModule),
    ],
}).catch(err => {
    console.error(err);
});
